import { GenerateUrl } from "@/core/Services/GlobalFunctions";
import ApiService from "@/core/Axios/ApiService";
import ConfigurationService from "@/core/Services/ConfigurationService";
import {
  AssignIcd,
  CreateCustomer,
  CreateMac,
  ICD,
  ICDCustomer,
  UnassignIcd,
} from "./ICDManagementTypes";

export default class IcdService {
  async getIcds({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }): Promise<ICD[]> {
    const url = GenerateUrl({
      path: "/api/icds",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
      config: {
        PageNumber: pageNumber,
        PageSize: pageSize,
      },
    });

    const response = await ApiService.get(url);
    return this._mapIcds(response.data.items);
  }

  async getCustomers({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }): Promise<ICDCustomer[]> {
    const url = GenerateUrl({
      path: "/api/icds/customers",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
      config: {
        PageNumber: pageNumber,
        PageSize: pageSize,
      },
    });

    const response = await ApiService.get(url);
    return this._mapCustomers(response.data.items);
  }

  async createIcd(assingIcd: AssignIcd): Promise<any> {
    const url = GenerateUrl({
      path: "/api/icds",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.post(url, assingIcd);
  }

  async assignIcd(assignIcd: AssignIcd): Promise<any> {
    const url = GenerateUrl({
      path: `/api/icds/assign/${assignIcd.mac}`,
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.put(url, assignIcd);
  }

  async unassignIcd(unassignIcd: UnassignIcd): Promise<any> {
    const url = GenerateUrl({
      path: `/api/icds/unassign/${unassignIcd.mac}`,
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.put(url, unassignIcd);
  }

  async createCustomer(assingIcd: CreateCustomer): Promise<any> {
    const url = GenerateUrl({
      path: "/api/icds/customers",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.post(url, assingIcd);
  }

  async createMac(createMac: CreateMac): Promise<any> {
    const url = GenerateUrl({
      path: "/api/icds/mac",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.post(url, createMac);
  }

  async updateICdCustomerTagName(icdCustomer: ICDCustomer): Promise<any> {
    const url = GenerateUrl({
      path: `/api/icds/customers`,
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.put(url, icdCustomer);
  }

  private _mapIcds(response: ICD[]): ICD[] {
    return response.map((icd) => this._mapIcd(icd));
  }

  private _mapIcd(icd: ICD): ICD {
    return {
      id: icd.id,
      customer: icd.customer,
      mac: icd.mac,
      customerId: icd.customerId,
      unassign:
        icd.customer !== null && icd.mac !== null ? "Assigned" : "Not assigned",
    };
  }

  private _mapCustomers(response: ICDCustomer[]): ICDCustomer[] {
    return response.map((customer) => this._mapCustomer(customer));
  }

  private _mapCustomer(customer: ICDCustomer): ICDCustomer {
    return {
      id: customer.id,
      name: customer.name,
    };
  }
}
